import { IsolatedScanCommentResponse } from "../types/types";
import { genericRequest, isolatedScanCommentRoute } from "./service";

/**
 * Gets all comments for a given isolated scan.
 * 
 * @param isolatedScanId to fetch comment for
 * 
 * @returns list of comments for the given isolated scan
 */
export const getIsolatedScanThzComments = async (isolatedScanId: number): Promise<IsolatedScanCommentResponse[] | Error> => {
  return await genericRequest({ url: `${isolatedScanCommentRoute}/${isolatedScanId}/thz`, method: "GET" });
}

/**
 * Adds a comment to a given isolated scan.
 * 
 * @param isolatedScanId to add comment to 
 * @param comment comment to add
 * 
 * @returns created comment
 */
export const addIsolatedScanThzComment = async (isolatedScanId: number, comment: string): Promise<IsolatedScanCommentResponse | Error> => {
  const body = JSON.stringify({
    comment: comment
  })
  return await genericRequest({ 
    url: `${isolatedScanCommentRoute}/${isolatedScanId}/thz`,
    method: "POST",
    body: body
  })
}

/**
 * Gets all comments for a given isolated scan thermal.
 * 
 * @param isolatedScanId to fetch comment for
 * 
 * @returns list of comments for the given isolated scan thermal
 */
export const getIsolatedScanThermalComments = async (isolatedScanId: number): Promise<IsolatedScanCommentResponse[] | Error> => {
  return await genericRequest({ url: `${isolatedScanCommentRoute}/${isolatedScanId}/ir`, method: "GET" });
}

/**
 * Adds a comment to a given isolated scan thermal.
 * 
 * @param isolatedScaThermalId to add comment to 
 * @param comment comment to add
 * 
 * @returns created comment
 */
export const addIsolatedScanThermalComment = async (isolatedScaId: number, comment: string): Promise<IsolatedScanCommentResponse | Error> => {
  const body = JSON.stringify({
    comment: comment,
  })
  return await genericRequest({ 
    url: `${isolatedScanCommentRoute}/${isolatedScaId}/ir`,
    method: "POST",
    body: body
  })
}

/**
 * Deletes an isolated scan comment.
 * 
 * @param id of comment to delete
 */
export const deleteComment = async (id: number) => {
  return await genericRequest({ url: `${isolatedScanCommentRoute}/${id}`, method: "DELETE" })
}